import { useCallback, useEffect, useState } from 'react';
import { Coins } from 'lucide-react';
import { Panel } from './Panel';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/credits`;

// Every credit-spending call this server allowed (estimated chars), plus the lock / daily cap / pinned script & bank.
export const CreditLogPanel = () => {
  const [st, setSt] = useState(null);
  const [rows, setRows] = useState([]);
  const load = useCallback(() => {
    fetch(`${API}/status`).then((r) => r.json()).then(setSt).catch(() => {});
    fetch(`${API}/log?limit=50`).then((r) => r.json()).then(setRows).catch(() => {});
  }, []);
  useEffect(() => {
    load();
  }, [load]);
  const p = (st && st.pins) || {};
  return (
    <Panel testId="credit-log-panel" code="12 / CREDITS" title="Credit log" right={<Coins size={18} className="text-[var(--teal)]" />}>
      <div className="space-y-3 text-xs">
        {st && (
          <div className="flex flex-wrap gap-x-6 gap-y-1">
            <span data-testid="credit-generation-status" className={st.generation_allowed ? 'text-[var(--amber)]' : 'text-[var(--spore)]'}>
              {st.generation_allowed ? 'GENERATION ALLOWED ON THIS SERVER' : 'GENERATION LOCKED ✓ (no credits can be spent)'}
            </span>
            <span data-testid="credit-today">TODAY {st.spent_today} / {st.daily_cap} CHARS (EST.)</span>
            <span data-testid="credit-pins">{p.pinned ? `PINNED · SCRIPT ${p.script_id} · SFX ${p.sfx_bank_id}` : 'NOT PINNED'}</span>
            <button type="button" data-testid="credit-refresh" className="btn-lab px-2 py-0.5" onClick={load}>Refresh</button>
          </div>
        )}
        <div data-testid="credit-log-rows" className="max-h-64 overflow-auto">
          {rows.length === 0 && <div className="text-[var(--dim)]">NO CREDIT-SPENDING CALLS LOGGED</div>}
          {rows.map((r) => (
            <div key={r.at + r.endpoint} className="grid grid-cols-[13rem_14rem_5rem_1fr] gap-2 border-b border-white/5 py-1">
              <span className="text-[var(--muted)]">{r.at.slice(0, 19).replace('T', ' ')}</span>
              <span>{r.endpoint}</span>
              <span>{r.chars}</span>
              <span className="truncate text-[var(--dim)]">{r.host}</span>
            </div>
          ))}
        </div>
      </div>
    </Panel>
  );
};
